<template>
  <v-layout>
    <v-flex>
      <v-toolbar flat>
        <h3 class="font-weight-light black--text">Pedido de Compra</h3>
        <v-spacer></v-spacer>

        <v-btn outlined color="default" class="mr-2" @click="$router.push({name: 'pedidosCompras'})">Voltar</v-btn>
        <v-btn outlined color="default" class="mr-2" @click="cadastrarPedidoCompra"
          v-if="$helper.verificaPermissao('cadastrar-pedido-compra')">Novo</v-btn>
        <v-btn outlined color="default" class="mr-2" @click="modalSalvar = true"
          v-if="$helper.verificaPermissao('cadastrar-pedido-compra') || $helper.verificaPermissao('atualizar-pedido-compra')">
          Salvar</v-btn>
        <v-btn outlined color="default" class="mr-2" @click="imprimirPedidoCompra(getPedidoCompra.id)"
          v-if="getPedidoCompra.id">
          Imprimir</v-btn>
        <v-menu bottom left transition="slide-y-transition" class="ml-10 mr-10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="cadastrarProduto" v-if="$helper.verificaPermissao('cadastrar-produto')">
              <v-list-item-action>
                <v-icon>window</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Produto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="cadastrarContato" v-if="$helper.verificaPermissao('cadastrar-contato')">
              <v-list-item-action>
                <v-icon>perm_identity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Contato</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="setModalEnviarEmailPedidoCompra(true) && getPedidoCompra.id">
              <v-list-item-action>
                <v-icon>email</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Enviar por e-mail</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="setModalExcluirPedidoCompra(true)"
              v-if="$helper.verificaPermissao('excluir-pedido-compra') && getPedidoCompra.id">
              <v-list-item-action>
                <v-icon>highlight_off</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Excluir Pedido</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn color="primary" class="ma-2" v-if="$route.params.id">Enviar por e-mail</v-btn> -->
      </v-toolbar>
      <v-container :fluid="true">
        <Alert></Alert>
        <v-card outlined>
          <v-card-title>
            <h6>Pesquisar Produtos (F2)</h6>
          </v-card-title>
          <v-form class="px-3">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <v-text-field dense outlined v-model="codigo_barras" id="codigo_barra" label="Código de Barras"
                    type="number" class="ml-1 mr-1" @keyup.enter="pesquisarPorCodigoDeBarras"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <!-- <v-autocomplete
                  label="Produto"
                  :items="getProdutos"
                  item-text="descricao"
                  item-value="id"
                  :search-input.sync="descricao"
                  outlined
                  v-model="getProduto.id"
                  @change="buscarProduto(getProduto.id)"
                  class="ml-3 mr-3"
                  > -->
                  <v-text-field dense v-model="getProduto.descricao" label="Produto" disabled outlined
                    class="ml-1 mr-1"></v-text-field>
                  <template v-slot:selection="data">{{data.item.descricao}} - {{data.item.marca}}</template>
                  <template v-slot:item="data">{{data.item.id}} - {{data.item.descricao}} -
                    {{data.item.marca}}</template>
                  <!-- </v-autocomplete> -->
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field dense outlined v-model="getProduto.preco_custo" @blur="somaTotalItem" label="P. Unit."
                    class="ml-1 mr-1" @keyup.enter="somaTotalItem(), focusInput('quantidade')" id="preco_unitario"
                    v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" @click="$event.target.select()"></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-autocomplete :items="getUnidadesMedidas" v-model="getProduto.unidade" label="UN" outlined dense
                    class="ml-1 mr-1" item-text="unidade" item-value="unidade" append-outer-icon="control_point"
                    @click:append-outer="cadastrarUnidadeMedida"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field dense outlined v-model="quantidade" @blur="somaTotalItem" label="Quantidade"
                    id="quantidade" @keyup.enter="addItemPedidoCompra" class="ml-1 mr-1"
                    v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" @click="$event.target.select()"></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field dense outlined v-model="total" label="Total" class="ml-1 mr-1" readonly
                    v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                    append-outer-icon="control_point" @click:append-outer="addItemPedidoCompra" @click="$event.target.select()"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-form>

          <!-- <v-card-actions>
            <v-btn color="primary" @click="addItemPedidoCompra" outlined block>INSERIR PRODUTO</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-container>


      <v-container grid-list-xs :fluid="true">
        <v-card outlined>
          <v-card-title>
            <h6>Produtos</h6>
          </v-card-title>
          <v-card-text>
            <hr>
            <v-simple-table dense fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left">Descrição</th>
                    <th class="text-left">UN</th>
                    <th class="text-left">P. Unit.</th>
                    <th class="text-left">Quantidade</th>
                    <th class="text-left">Vr. Total</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in getItensPedidoCompra" :key="p.id">
                    <td>{{ p.produto_id }}</td>
                    <td>{{ p.descricao }}</td>
                    <td>{{ p.unidade }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.preco)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.quantidade)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.total)) }}</td>
                    <td>
                      <v-btn x-small color="error" @click="removeItemPedidoCompra(p)" outlined>
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <hr>
            <br>
            <h4>Pesquisar Fornecedor (F3)</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12 md9>
                <v-layout row wrap>
                  <v-flex xs12 md3>
                    <v-text-field outlined @input="debouncedBuscarContato" dense v-model="getContato.id"
                      label="Código do Fornecedor" type="number" class="ml-1 mr-1" @keyup.enter="debouncedBuscarContato"
                      id="codigo_cliente"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field outlined v-model="getContato.nome" dense label="Nome" class="ml-1 mr-1"
                      append-outer-icon="edit" @click:append-outer="visualizarContato(getContato.id)">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <h4>Totais da Compra</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12 md3>
                <v-text-field outlined v-model="descontoPercentual" dense label="Desconto %"
                  v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" id="desconto_percentual"
                  @keyup.enter="modalSalvar = true" class="mr-1 ml-1" @click="$event.target.select()"></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field outlined v-model="descontoReal" dense label="Desconto R$"
                  v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" id="desconto_percentual"
                  @keyup.enter="modalSalvar = true" class="ml-1 ml-1" @click="$event.target.select()"></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field outlined v-model="getPedidoCompra.total" dense label="Total" disabled class="ml-1 mr-1">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field outlined v-model="getPedidoCompra.frete" dense label="Frete" class="ml-1 mr-1"
                  v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" @click="$event.target.select()">
                </v-text-field>
              </v-flex>
            </v-layout>
            <h4>Detalhes da Compra</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12 md4>
                <v-text-field outlined dense class="ml-1 mr-1" label="Ordem Compra" type="number"
                  v-model="getPedidoCompra.ordem_compra"></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field type="date" outlined dense class="ml-1 mr-1" label="Data Compra"
                  v-model="getPedidoCompra.data_compra"></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field type="date" outlined dense class="ml-1 mr-1" label="Data Prevista"
                  v-model="getPedidoCompra.data_prevista"></v-text-field>
              </v-flex>
            </v-layout>
            <h4>Transportador</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12 md3>
                <v-autocomplete class="mr-1 ml-1" v-model="getPedidoCompra.transportadora_id"
                  :items="getTransportadoras" item-text="nome" item-value="id" outlined dense
                  append-outer-icon="control_point" @click:append-outer="cadastrarContato" label="Transportadora">
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <v-select :items="opcoesResponsabilidadeFrete" v-model="getPedidoCompra.reponsabilidade_frete" outlined
                  dense label="Frete por conta" class="ml-1 mr-1">
                </v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field label="Quantidade de Volumes" v-model="getPedidoCompra.quantidade_volume" id="id" outlined
                  dense type="number"></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field label="Peso Bruno" v-model="getPedidoCompra.peso_bruto" id="id" outlined dense
                  class="ml-1 mr-1" v-mask="['#,###', '##,###', '###,###']" @click="$event.target.select()"></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea label="Dados Adicionais" v-model="getPedidoCompra.dados_adicionais" outlined dense
                  class="ml-1 mr-1"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="success" @click="modalSalvar = true" block
              v-if="$helper.verificaPermissao('cadastrar-pedido-compra') || $helper.verificaPermissao('atualizar-pedido-compra')">
              SALVAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>

    <v-dialog v-model="modalSalvar" max-width="720">
      <v-card>
        <v-card-title>Salvar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="default" @click="modalSalvar = false">Não</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="success" @click="salvar">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalCadastroProduto />
    <ModalCadastroContato />
    <ModalPesquisarProduto exibirPrecoCusto="true" />
    <ModalPesquisarContato />
    <ModalEnviarPedidoCompraEmail />
    <ModalCadastroUnidadeMedida />
    <ModalExcluirPedidoCompra />

  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProdutoService from '@/services/ProdutoService'
  import ContatoService from '@/services/ContatoService'
  // import ModalExcluirOrcamento from '@/pages/orcamento/ModalExcluir'
  import ModalCadastroContato from '@/pages/contato/ModalCadastro'
  import ModalPesquisarContato from '@/pages/contato/ModalPesquisar'
  import ModalCadastroProduto from '@/pages/produto/ModalCadastro'
  import ModalPesquisarProduto from '@/pages/produto/ModalPesquisarProduto'
  // import ModalImprimirOrcamento from '@/pages/orcamento/ModalImprimir'
  import ModalEnviarPedidoCompraEmail from '@/pages/pedidoCompra/ModalEnviarEmail'
  import ModalCadastroUnidadeMedida from '@/pages/produto/unidadeMedida/ModalCadastro'
  import ModalExcluirPedidoCompra from '@/pages/pedidoCompra/ModalExcluir'
  var _ = require('lodash');

  export default {
    components: {
      ModalCadastroContato,
      ModalCadastroProduto,
      ModalPesquisarProduto,
      ModalPesquisarContato,
      // ModalExcluirOrcamento,
      // ModalImprimirOrcamento,
      ModalEnviarPedidoCompraEmail,
      ModalCadastroUnidadeMedida,
      ModalExcluirPedidoCompra
    },
    data() {
      return {
        cliente_id: 1,
        produto_id: "",
        descricao: "",
        preco: "",
        desconto: 0,
        total: "",
        codigo_barras: "",
        quantidade: '1,00',
        descontoPercentual: 0,
        descontoReal: 0,
        tabs: 0,
        modalSalvar: false,
        rules: {
          nome: [
            v => !!v || 'Campo obrigatório.'
          ],
        },
        // modalImprimirOrcamento: false,
        modalConverterVendaOrcamento: false,
        opcoesResponsabilidadeFrete: [
          'FORNECEDOR',
          'CLIENTE'
        ]
      }
    },
    computed: {
      ...mapGetters([
        'getPedidoCompra',
        'getItensPedidoCompra',
        'getProduto',
        'getProdutos',
        'getContato',
        'getContatos',
        'getTransportadoras',
        'getUnidadesMedidas',
        'getModalPesquisarProdutosOrcamento'
      ]),
    },
    watch: {
      descricao: function () {
        this.debouncedPesquisarPorDescricao()
      },
      codigo_barras: function () {
        if (this.codigo_barras != '') {
          this.debouncedPesquisarPorCodigoDeBarras()
        }
      },
      quantidade: function () {
        if (this.quantidade != '' && this.quantidade != 0) {
          this.somaTotalItem()
        }
      },
      descontoPercentual: function () {
        this.aplicaDescontoPercentual()
      },
      descontoReal: function () {
        this.aplicaDescontoReal()
      },
      getModalPesquisarProdutosOrcamento(){
        if(this.getModalPesquisarProdutosOrcamento == false){
          if(this.getProduto.id){
             setTimeout(() => {
               this.focusInput('preco_unitario')
             }, 150)
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'cadastrarContato',
        'cadastrarProduto',
        'salvarPedidoCompra',
        'atualizarPedidoCompra',
        'buscarCliente',
        'pesquisarProdutoPorCodigoDeBarras',
        'listarProdutos',
        'listarContatos',
        'cadastrarPedidoCompra',
        'visualizarPedidoCompra',
        'visualizarProduto',
        'buscarProduto',
        'setModalPesquisarProdutosOrcamento',
        'pesquisarProduto',
        'setModalPesquisarContato',
        'setDrawer',
        'buscarContato',
        'visualizarContato',
        'setModalEnviarEmailPedidoCompra',
        'listarTransportadoras',
        'listarUnidadeMedida',
        'cadastrarUnidadeMedida',
        'imprimirPedidoCompra',
        'setModalExcluirPedidoCompra'
      ]),
      salvar() {
        if (!this.getContato.id) {
          this.getContato.id = null
        }

        this.modalSalvar = false
        this.getPedidoCompra.desconto = this.getPedidoCompra.subtotal - this.getPedidoCompra.total
        this.getPedidoCompra.itens = this.getItensPedidoCompra
        this.getPedidoCompra.desconto = this.descontoReal
        this.getPedidoCompra.fornecedor_id = this.getContato.id
        if (this.getPedidoCompra.id) {
          this.atualizarPedidoCompra(this.getPedidoCompra)
        } else {
          this.salvarPedidoCompra(this.getPedidoCompra)
        }
      },

      somaTotalItem() {
        if(!this.getProduto.preco_custo){
          this.getProduto.preco_custo = '0,00'
        }

        if(!this.quantidade) {
          this.quantidade = '1,00'
        }

        this.total = this.$helper.formatReal(this.$helper.cleanFormatReal(this.quantidade) * this.$helper.cleanFormatReal(this.getProduto.preco_custo))
      },
      addItemPedidoCompra() {

        if(!this.quantidade) {
          this.quantidade = '1,00'
        }

        if (!this.getProduto.descricao) {
          this.$store.commit('snackbarError', 'Selecione um produto.')
          return
        }

        let item = {
          produto_id: this.getProduto.id,
          descricao: this.getProduto.descricao,
          unidade: this.getProduto.unidade,
          preco: this.$helper.cleanFormatReal(this.getProduto.preco_custo),
          quantidade: this.$helper.cleanFormatReal(this.quantidade),
          total: this.$helper.cleanFormatReal(this.total),
        }

        this.$store.commit("addItemPedidoCompra", item)
        this.getPedidoCompra.subtotal = this.$helper.formatReal(parseFloat(this.$helper.cleanFormatReal(this.getPedidoCompra.subtotal) + item.total))
        this.getPedidoCompra.total = this.getPedidoCompra.subtotal

        this.codigo_barras = ""
        this.quantidade = "1,00"
        this.produto_id = ""
        document.getElementById("codigo_barra").focus()
        this.$store.commit('setProduto', {})
        this.getProduto.preco_custo = this.$helper.formatReal(parseFloat(0))
      },
      _buscarContato() {
        this.buscarContato(this.getContato.id)
      },
      removeItemPedidoCompra(item) {
        this.getPedidoCompra.subtotal = this.$helper.formatReal(this.$helper.cleanFormatReal(this.getPedidoCompra.subtotal) - item.total)
        this.getPedidoCompra.total = this.getPedidoCompra.subtotal
        this.aplicaDescontoPercentual()
        this.aplicaDescontoReal()
        this.$store.commit('removeItemPedidoCompra', item)
      },
      aplicaDescontoPercentual() {
        let subtotal = parseFloat(this.$helper.cleanFormatReal(this.getPedidoCompra.subtotal.toString()))
        let desconto = parseFloat(this.$helper.cleanFormatReal(this.descontoPercentual.toString()))

        if (this.descontoPercentual) {
          this.descontoReal = 0
          this.getPedidoCompra.total = this.$helper.formatReal(parseFloat(subtotal - ((desconto / 100) * subtotal)))
        } else {
          this.getPedidoCompra.total = this.getPedidoCompra.subtotal
        }

      },
      aplicaDescontoReal() {
        let subtotal = parseFloat(this.$helper.cleanFormatReal(this.getPedidoCompra.subtotal.toString()))
        let desconto = parseFloat(this.$helper.cleanFormatReal(this.descontoReal.toString()))
        // console.log('desconto', desconto)
        // console.log('subtotal', subtotal)
        if (desconto > subtotal) {
          // this.$store.commit('snackbarWarning', 'Desconto não permitido.')
          this.descontoReal = '0,00'
        }

        if (this.descontoReal && desconto <= subtotal) {
          this.descontoPercentual = 0
          
          this.getPedidoCompra.total = this.$helper.formatReal(parseFloat(subtotal - desconto))
        } else {
          this.getPedidoCompra.total = this.getPedidoCompra.subtotal
        }
      },
      pesquisarPorCodigoDeBarras() {
        if (this.codigo_barras == "") {
          document.getElementById("codigo_cliente").focus()
          return;
        }

        ProdutoService.porCodigoDeBarras(this.codigo_barras)
          .then(res => {
            if (res.data.id) {
              let produto = res.data
              produto.preco_venda = this.$helper.formatReal(parseFloat(res.data.preco_venda))
              this.$store.commit('setProduto', produto)
              this.$store.commit('setItemPedidoCompra', produto)
              this.somaTotalItem()
              document.getElementById("preco_unitario").focus()
            } else {
              this.$store.commit('snackbarError', 'Produto não encontado.')
              this.codigo_barras = ''
              document.getElementById("codigo_barra").focus()

            }
          })
          .catch(e => {
            this.codigo_barras = ''
            document.getElementById("codigo_barra").focus()
            this.$store.commit('snackbarError', 'Erro ao pesuisar produto.')
            console.log(e)
          })

      },
      pesquisarPorDescricao() {
        let data = {
          campo: 'descricao',
          valor: this.descricao
        }

        this.pesquisarProduto(data)
      },
      focusPrecoUnitario() {
        document.getElementById("preco_unitario").focus()
      },
      // focusQuantidade() {
      //   setTimeout(() => {
      //     console.log('focus_quantidade')
      //     document.getElementById("preco_unitario").focus()
      //     this.somaTotalItem()
      //   }, 100)
      // },
      focusDescontoPercentual() {
        document.getElementById("desconto_percentual").focus()
      },
      focusCodigoDeBarra() {
        document.getElementById("codigo_barra").focus()
      },
      focusInput(InputId) {
        document.getElementById(InputId).focus();
      },
      keyUp(e) {
        if (!e) e = window.event
        let keyCode = e.keyCode || e.which
        if (keyCode == 113) e.preventDefault()
        if (keyCode == 114) e.preventDefault()

        if (keyCode == 113) {
          this.setModalPesquisarProdutosOrcamento(true)
        }

        if (keyCode == 114) {
          this.setModalPesquisarContato(true)
        }
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.visualizarPedidoCompra(this.$route.params.id)
      }
    },
    created() {
      this.getProduto.preco_custo = "0,00"
      this.listarTransportadoras()
      this.listarUnidadeMedida()
      this.setModalPesquisarProdutosOrcamento(false)
      this.setModalPesquisarContato(false)
      this.debouncedPesquisarPorCodigoDeBarras = _.debounce(this.pesquisarPorCodigoDeBarras, 300)
      this.debouncedPesquisarPorDescricao = _.debounce(this.pesquisarPorDescricao, 300)
      this.debouncedBuscarContato = _.debounce(this._buscarContato, 500)

      document.addEventListener('keydown', this.keyUp)
    },
    beforeMount() {
      setTimeout(() => {
        this.setDrawer(false)
      }, 100)
    },
    beforeDestroy() {
      this.$store.commit('setContato', {})
      this.$store.commit('setProdutoVenda', {})
      this.$store.commit('setProduto', {})
      
    }
  }
</script>